import i18next from "i18next";
import React from "react";
import { Button, Card } from "react-bootstrap";

type Props = {
  title?: React.ReactNode;
  message?: React.ReactNode;
  action?: { name: string; onClick: () => void };
}

const VehicleEmptyState = ({ title, message, action }: Props) => {
  return (
    <Card className="text-center mt-4">
      {title && <Card.Title>{title}</Card.Title>}
      <Card.Body>
        <Card.Text>
          {message || i18next.t('empty_state_message')}
        </Card.Text>
        {action && <Button variant="primary" onClick={action.onClick}>{action.name}</Button>}
      </Card.Body>
    </Card>
  )
}

export default VehicleEmptyState;
